module.exports = __webpack_public_path__ + "static/media/iconDelete.d59ff21d.svg";